import { render } from "./OpenSeadragonViewer.vue?vue&type=template&id=1ce3ebbd&scoped=true"
import script from "./OpenSeadragonViewer.vue?vue&type=script&lang=js"
export * from "./OpenSeadragonViewer.vue?vue&type=script&lang=js"

import "./OpenSeadragonViewer.vue?vue&type=style&index=0&id=1ce3ebbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce3ebbd"]])

export default __exports__